<template>
  <div class="app flex-row align-items-center">
    <Alerts />
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-form ref="signupForm" @submit="onSignupSubmit" :validated="isValid">
            <b-card-group>
              <LoadingSpinner v-if="isLoading" />
              <b-card class="card-border-blue px-5">
                <p class="text-center mb-0">
                  <img src="/images/GS Logo Small.jpg" width="200" class="img-responsive" />
                  <img v-if="isUsps" src="/images/usps/logo.png" width="200" class="img-responsive" />
                </p>
                <div class="text-muted text-center mb-1 h6">
                  <span v-if="isUsps">USPS Portal Registration</span>
                  <span v-else>Create an Account</span>
                </div>
                <b-card-body>
                  <b-form-row>
                    <!-- FIRST NAME -->
                    <b-col>
                      <b-form-group class="mb-1" label-for="signup-first-name" description>
                        <b-form-input id="signup-first-name" key="signup-first-name" type="text" v-model="form.first_name"
                          name="first_name" v-validate="{ required: true }" required placeholder="First name"
                          tabindex="1"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <!-- LAST NAME -->
                    <b-col>
                      <b-form-group class="mb-1" label-for="signup-last-name" description>
                        <b-form-input id="signup-last-name" type="text" v-model="form.last_name" name="last_name"
                          v-validate="{ required: true }" required placeholder="Last name" tabindex="2"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-form-row>

                  <b-form-row>
                    <!-- COMPANY -->
                    <b-col>
                      <b-form-group class="mb-1" label-for="signup-company" description>
                        <b-form-input id="signup-company" type="text" v-model="form.company" name="company"
                          placeholder="Company Name (if available)" :disabled="isUsps" tabindex="3"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-form-row>

                  <b-form-row>
                    <!-- PHONE -->
                    <b-col sm="8">
                      <b-form-group class="mb-1" label-for="signup-phone-number" description>
                        <b-form-input id="signup-phone-number" type="tel" v-model="form.phone_number" name="phone_number"
                          v-mask="'(###) ###-####'" v-validate="{ required: true }" required placeholder="Phone number"
                          tabindex="4"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <!-- EXT -->
                    <b-col sm="4">
                      <b-form-group class="mb-1" label-for="signup-ext" description>
                        <b-form-input id="signup-ext" type="text" v-model="form.ext" name="ext" placeholder="Ext."
                          tabindex="4"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-form-row>

                  <b-form-row v-if="isUsps">
                    <!-- Title -->
                    <b-col>
                      <b-form-group class="mb-1" label-for="signup-title" description>
                        <b-form-select v-model="form.title" :options="uspsTitles" v-validate="{ required: true }" required
                          tabindex="5">
                          <template slot="first">
                            <option :value="null" disabled>Title (Territory Rep, Inside Sales, etc.)</option>
                          </template>
                        </b-form-select>
                        <!-- <b-form-input
                          type="text"
                          v-model="form.title"
                          name="title"
                          v-validate="{required: true}"
                          required
                          placeholder="Title (Territory Rep, Inside Sales, etc.)"
                          list="signup-title"
                          @change="uspsTitleSelect"
                          tabindex="5"
                        ></b-form-input>
                        <datalist id="signup-title">
                          <option v-for="(item, i) in uspsTitles" v-bind:key="i" :value="item.value">
                            {{ item.text }}
                          </option>
                        </datalist> -->
                      </b-form-group>
                    </b-col>
                    <!-- District -->
                    <b-col>
                      <b-form-group class="mb-1" label-for="signup-district" description>
                        <b-form-input id="signup-district" type="text" v-model="form.district" name="district"
                          v-validate="{ required: true }" required placeholder="District (Southeast, WestPac1, etc.)"
                          tabindex="6"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-form-row>

                  <b-form-row v-if="!isUsps">
                    <!-- USPS REP ID -->
                    <b-col>
                      <b-form-group class="mb-1" label-for="signup-rep-id" description>
                        <b-form-input id="signup-rep-id" type="text" v-model="form.rep_id" name="red_id"
                          placeholder="USPS Rep I.D. (if available)" tabindex="7"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-form-row>

                  <b-form-row>
                    <!-- USPS REP ID -->
                    <b-col>
                      <b-form-group class="mb-1" label-for="signup-survey" description>
                        <b-form-select v-model="form.survey" :options="surveys" v-validate="{ required: true }" required
                          tabindex="9">
                          <template slot="first">
                            <option :value="null" disabled>How did you hear about us?</option>
                          </template>
                        </b-form-select>
                        <!-- <b-form-input
                          type="text"
                          v-model="form.survey"
                          name="survey"
                          placeholder="How did you hear about us?"
                          tabindex="8"
                          required
                          list="signup-survey"
                        ></b-form-input>
                        <datalist id="signup-survey">
                          <option v-for="(item, i) in surveys" v-bind:key="i" :value="item.value">
                            {{ item.text }}
                          </option>
                        </datalist> -->
                      </b-form-group>
                    </b-col>
                  </b-form-row>

                  <b-form-row>
                    <b-col>
                      <b-form-group class="mb-1" label-for="signup-email-address" description>
                        <b-form-input id="signup-email-address" type="email" name="email_address"
                          v-model="form.email_address"
                          v-validate="isUsps ? { required: true, regex: /@usps\.gov$/ } : { required: true }"
                          @change="checkUSPS" @keyup="removeError" required placeholder="Email Address" ref="email"
                          tabindex="10"></b-form-input>
                        <!-- @change="checkEmail" -->
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group class="mb-1" label-for="signup-email-address-confirm" description>
                        <b-form-input id="signup-email-address-confirm" type="email" name="email_address_confirmation"
                          v-model="form.email_address_confirmation" v-validate="{ required: true }" required
                          placeholder="Confirm Email Address" ref="email_confirmation" tabindex="11"></b-form-input>
                        <!-- @change="checkMatch" -->
                      </b-form-group>
                    </b-col>
                  </b-form-row>

                  <b-form-row>
                    <b-col>
                      <b-input-group class="mb-1 default">
                        <b-form-input :type="isPasswordVisible ? 'text' : 'password'" placeholder="Password"
                          class="pw-input" v-model="form.password" v-validate="{ required: true }" required
                          @focus="passwordClass = 'on-focus'" @blur="passwordClass = ''" tabindex="12"></b-form-input>
                        <b-input-group-append>
                          <b-btn :class="['btn-blue', 'default', 'rounded-right', passwordClass]"
                            @click="isPasswordVisible = !isPasswordVisible"><i
                              :class="['fa', isPasswordVisible ? 'fa-eye' : 'fa-eye-slash']"
                              aria-hidden="true"></i></b-btn>
                        </b-input-group-append>
                      </b-input-group>
                    </b-col>

                    <b-col>
                      <b-input-group class="mb-1 default">
                        <b-form-input :type="isConfirmPasswordVisible ? 'text' : 'password'" class="pw-input"
                          placeholder="Confirm Password" v-model="form.password_confirmation"
                          v-validate="{ required: true }" @focus="confirmPasswordClass = 'on-focus'"
                          @blur="confirmPasswordClass = ''" required tabindex="13"></b-form-input>
                        <b-input-group-append>
                          <b-btn :class="['btn-blue', 'default', 'rounded-right', confirmPasswordClass]"
                            @click="isConfirmPasswordVisible = !isConfirmPasswordVisible"><i
                              :class="['fa', isConfirmPasswordVisible ? 'fa-eye' : 'fa-eye-slash']"
                              aria-hidden="true"></i></b-btn>
                        </b-input-group-append>
                      </b-input-group>
                    </b-col>
                  </b-form-row>

                  <b-form-group class="mb-1" :invalid-feedback="errors.first('accept_terms')">
                    <b-form-checkbox plain required v-model="form.accept_terms" :value="1" :unchecked-value="0"
                      tabindex="14">
                      <small>
                        I have read and agree to the
                        <a class="text-blue" href="https://www.grandshipper.com/terms-conditions/" target="_blank">Terms
                          and Conditions</a>
                        and
                        <a class="text-blue" href="https://www.grandshipper.com/privacy-policy/" target="_blank">Privacy
                          Policy</a>
                        of GrandShipper Inc.
                      </small>
                    </b-form-checkbox>
                  </b-form-group>

                  <vue-recaptcha ref="recaptcha" @verify="onVerify" @expired="onExpired"
                    sitekey="6Le4ZOIZAAAAAICTOtGscXnXcbOrw8FLkxpfDo1H" size="invisible"></vue-recaptcha>

                  <div class="text-center">
                    <b-btn :disabled="!canSubmit" type="submit" block class="default rounded-pill btn-blue" tabindex="15"
                      style="padding: 2px 1px; opacity: 1;">Create your Account</b-btn>

                    <div class="mt-2">
                      Already have an account?

                      <b-btn variant="primary" v-if="isUsps" href="https://usps.grandshipper.com/login">back</b-btn>
                      <b-btn variant="primary" v-else to="/auth/login">Back</b-btn>
                    </div>
                  </div>

                  <!-- <p class="mt-3 text-center">
                    <span v-if="isUsps">
                      You must use your @usps.gov email address but please
                      <span style="color: red;">"DO NOT" use any password credentials </span>
                      that you use at a government level for security purposes.
                    </span>
                    <span v-else>
                      Please enter your email address and password. You will use these credentials to log into GrandShipper application.
                    </span>
                  </p>
                  <b-form-row>
                    <b-col>
                      <b-form-group
                        class="mb-1"
                        label-for="signup-email-address"
                        description
                      >
                        <b-form-input
                          id="signup-email-address"
                          type="email"
                          name="email_address"
                          v-model="form.email_address"
                          v-validate="isUsps ? {required: true, regex: /@usps\.gov$/} : {required: true}"
                          @change="checkEmail"
                          @keyup="removeError"
                          required
                          placeholder="Email Address"
                          ref="email"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group
                        class="mb-1"
                        label-for="signup-email-address-confirm"
                        description
                      >
                        <b-form-input
                          id="signup-email-address-confirm"
                          type="email"
                          name="email_address_confirmation"
                          v-model="form.email_address_confirmation"
                          v-validate="{required: true}"
                          required
                          placeholder="Confirm Email Address"
                          @change="checkMatch"
                          ref="email_confirmation"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-form-row>
                  <b-alert variant="danger" :show="showAlert">
                    <em style="color: black;">
                      Sorry, but the email you have entered could not be verified by our system.
                      Please double check and try again.
                      If the problem persists, please <a href="https://www.grandshipper.com/contact/">contact us</a> to resolve the issue.
                    </em>
                  </b-alert>
                  <b-form-row>
                    <b-col>
                      <b-form-group
                        class="mb-1"
                        label-for="signup-password"
                        description
                      >
                        <b-form-input
                          id="signup-password"
                          type="password"
                          name="password"
                          v-model="form.password"
                          v-validate="{required: true}"
                          required
                          placeholder="Password (please write down)"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group
                        class="mb-1"
                        label-for="signup-password-confirm"
                        description
                      >
                        <b-form-input
                          id="signup-password-confirm"
                          type="password"
                          name="password_confirmation"
                          v-model="form.password_confirmation"
                          v-validate="{required: true}"
                          required
                          placeholder="Confirm Password"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-form-row> -->
                </b-card-body>
              </b-card>
            </b-card-group>
          </b-form>
        </b-col>
      </b-row>
    </div>

    <b-modal ref="modal" size="md" centered lazy :hide-footer="true" :hide-header="true" @hide="gotoLogin()"
      class="modal-continue">
      <span @click="gotoLogin" class="close cursor-pointer">×</span>

      <div class="text-center pt-3" v-if="!isUsps">
        <p class="text-left">Your GrandShipper account is <u class="font-italic">almost</u> complete. &nbsp;Click continue
          and log in. &nbsp;After successfully logging in, please follow the instructions provided.</p>
        <b-btn class="btn-blue" @click="gotoLogin()">Continue</b-btn>
      </div>
      <div v-else>
        <p>
          Please check your email inbox to verify your email address. <br />
          If you did not receive the email, please check your spam.
        </p>
      </div>
    </b-modal>

    <b-modal ref="uspsTitle" id="usps-title" :hide-header="true" :hide-footer="true" centered>
      <b-input-group class="mt-2">
        <b-form-input ref="uspsModalTitle" type="text" v-model="form.title" placeholder="Other: (enter title)"
          @keypress.enter="$refs.uspsTitle.hide()"></b-form-input>
        <b-input-group-append>
          <b-btn variant="primary" class="default px-3" size="sm" @click="$refs.uspsTitle.hide()">
            OK
          </b-btn>
        </b-input-group-append>
      </b-input-group>
    </b-modal>
  </div>
</template>

<style lang="scss">
.modal-continue {
  .modal-body {
    padding-top: 8px;
  }
}
</style>

<style lang="scss" scoped>
.custom-select:invalid,
.custom-select.is-invalid {
  background-color: #ffffff;
  color: #495057;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  padding: 0.375rem 0.75rem;
}

.pw-input {
  border-right: 0;
}

.pw-btn {
  background: transparent;
  border: 1px solid #ced4da;
  border-left: 0;

  &.on-focus {
    border-color: #ffecba;
  }
}

.was-validated .form-control:valid,
.was-validated .form-control:valid:focus,
.form-control.is-valid,
.form-control.is-valid:focus {
  +.input-group-append button {
    border-color: #000;
  }
}
</style>

<script>
import LoadingSpinner from "../../components/LoadingSpinner";
import countries from "../../data/countries.js";
import router from "../../router";
import axios from "axios";
import Alerts from "../../components/Alerts";

import VueRecaptcha from "vue-recaptcha";

export default {
  name: "Register",

  components: {
    LoadingSpinner,
    Alerts,
    VueRecaptcha
  },
  props: {
    isUsps: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      isPasswordVisible: false,
      isConfirmPasswordVisible: false,
      passwordClass: '',
      confirmPasswordClass: '',
      isLoading: false,
      isValid: false,
      showAlert: false,
      form: { country: "US", captcha: null, company: this.isUsps ? "United States Postal Service" : null, title: null, survey: null },
      signup_url: "",
      uspsTitles: [
        // { value: null, text: 'Select title' },
        { value: 'Sr. Inside Sales Rep', text: 'Sr. Inside Sales Rep' },
        { value: 'Inside Sales Rep', text: 'Inside Sales Rep' },
        { value: 'Sr. Territory Rep', text: 'Sr. Territory Rep' },
        { value: 'Territory Rep', text: 'Territory Rep' },
        { value: 'Other: (enter title)', text: 'Other: (enter title)' },
      ],
      surveys: [
        // { value: null, text: 'Select survey' },
        { value: 'Search Engine (Google, Bing, etc.)', text: 'Search Engine (Google, Bing, etc.)' },
        { value: 'Social Media (Instagram, Facebook, LinkedIn)', text: 'Social Media (Instagram, Facebook, LinkedIn)' },
        { value: 'Referred by Existing Customer', text: 'Referred by Existing Customer' },
        { value: 'USPS Representative', text: 'USPS Representative' },
        { value: 'GrandShipper Employee', text: 'GrandShipper Employee' },
        { value: 'Pitney Bowes Representative', text: 'Pitney Bowes Representative' },
        { value: 'Friends or Family', text: 'Friends or Family' },
        { value: 'Word of Mouth', text: 'Word of Mouth' },
      ],
      //errors: {},
    };
  },
  computed: {
    countrySelectOptions() {
      return countries.getSelectOptions();
    },
    canSubmit() {
      // return (this.form.accept_terms && this.isValid)? true : false;
      if (this.isUsps && this.form.title && this.form.accept_terms
        && this.form.first_name && this.form.last_name && this.form.phone_number
        && this.form.survey && this.form.email_address && this.form.email_address_confirmation
        && this.form.password && this.form.password_confirmation) {
        return true
      } else if (this.form.accept_terms && this.form.first_name
        && this.form.last_name && this.form.phone_number && this.form.survey
        && this.form.email_address && this.form.email_address_confirmation
        && this.form.password && this.form.password_confirmation) {
        return true
      }
      return false
    }
  },
  mounted() {
    // this.$refs.modal.show()
    const { rep_id } = this.$route.params;
    console.log('rep id', rep_id);
    if (rep_id) {
      this.form.rep_id = rep_id.toUpperCase();
      this.form.survey = 'USPS Representative'
    }
    /*
    this.isLoading = true;

    axios
      .get("/pb/merchant_signup_url")
      .then(response => {
        if (response.data.url) {
          this.signup_url = response.data.url;
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
      */
  },

  methods: {
    async newValidate() {
      console.log("newValidate Called")
      const pattern = /@usps\.gov$/;
      const email = this.form.email_address;
      try {
        console.log("Email: ", email)
        if (!pattern.test(email)) {
          console.log("check email");
          const checkURL = `${process.env.MIX_INTEG_URL}/check-email`;
          const { data: { status, message, error } } = await axios.post(checkURL, { e: email });
          console.log("status: ", status);
          console.log("error: ", error);
          if (error && status == false) {
            throw new Error(error);
          }
        }
        this.isValid = true;
        this.showAlert = false;
        await this.complete();
      } catch (error) {
        this.isValid = false;
        this.showAlert = true;
        this.$refs.email.select();
        this.$emit("alert", {
          message: `Email ${email} is not valid`,
          type: "danger"
        });
      }

      const email_confirmation = this.form.email_address_confirmation;
      if (email != email_confirmation) {
        // alert("Email did not match");
        this.$emit("alert", {
          message: `Email did not match`,
          type: "danger"
        });
        this.$refs.email_confirmation.select()
      }
    },

    async checkUSPS() {
      const pattern = /@usps\.gov$/;
      const email = this.form.email_address;

      if (pattern.test(email) && !this.isUsps) {
        alert("Hi USPS Rep!  I see that you are trying to register but this page is for Customers only.  You will now be redirected to the USPS Portal Registration page.");
        window.location = "https://usps.grandshipper.com/register";
        return;
      } else if (this.isUsps && !pattern.test(email)) {
        alert("Hi USPS Rep!  Please use your @usps.gov email to register.");
      }
    },

    async checkMatch(e) {
      await this.checkEmail();
      const email = this.form.email_address;
      const email_confirmation = this.form.email_address_confirmation;
      if (email != email_confirmation) {
        alert("Email did not match");
        this.$refs.email_confirmation.select()
      }
    },
    async removeError() {
      this.showAlert = false;
    },
    async checkEmail(e) {
      const pattern = /@usps\.gov$/;
      const email = this.form.email_address;
      try {
        // check regular users only
        if (!pattern.test(email)) {
          const checkURL = `${process.env.MIX_INTEG_URL}/check-email`;
          const { data: { status, message, error } } = await axios.post(checkURL, { e: email });
          if (error && status == false) {
            throw new Error(error);
          }
        }

        this.isValid = true;
        this.showAlert = false;
        // check that the email ends with usps.gov
        if (pattern.test(email) && !this.isUsps) {
          alert("Hi USPS Rep!  I see that you are trying to register but this page is for Customers only.  You will now be redirected to the USPS Portal Registration page.");
          window.location = "https://usps.grandshipper.com/register";
          return;
        } else if (this.isUsps && !pattern.test(email)) {
          alert("Hi USPS Rep!  Please use your @usps.gov email to register.");
        }
      } catch (e) {
        console.log(`Email(${email}) is not valid`);
        this.$refs.email.select();
        this.isValid = false;
        this.showAlert = true;
        this.$emit("alert", {
          message: `Email ${email} is not valid`,
          type: "danger"
        });
      }
    },

    async onSignupSubmit(e) {
      e.preventDefault();
      const valid = await this.$validator.validateAll();

      if (valid) {
        if (this.form.captcha) {
          // await this.checkEmail();
          await this.newValidate()
        } else {
          // no token / it expires
          this.$refs.recaptcha.execute();
        }
      }
      else {
        const errs = this.errors.all();
        console.error("Form is not valid");
        console.error(errs);
        // alert(errs.pop().replace(/_/g, ' '));
        this.$emit("alert", {
          message: `${errs.pop().replace(/_/g, ' ')}`,
          type: "danger"
        });
      }
    },
    onSignupReset(e) { },

    async onVerify(token) {
      this.form.captcha = token;
      console.log('onVerify called');
      await this.newValidate();
    },

    onExpired() {
      this.form.captcha = null;
      console.log('recaptcha expries');
    },

    async complete(e) {
      console.log("complete called");
      if (!this.canSubmit) {
        return;
      }

      //e.preventDefault();

      this.isLoading = true;

      const requestData = { ...this.form, is_usps: this.isUsps };
      console.log('requestdata', requestData);

      const url = this.isUsps ? "/users/signup-usps" : "/users/signup";

      axios
        .post(url, requestData)
        .then(async response => {
          this.$refs.modal.show();
        })
        .catch(e => {
          console.log('recaptcha reset');
          this.form.captcha = null;
          this.$refs.recaptcha.reset();

          if (e.response) {
            const errors = e.response.data.errors ? e.response.data.errors : {};
            console.log('SERver Error: ', errors);
            const errorKeys = Object.keys(errors);
            if (errorKeys.length > 0) {
              const k = errorKeys.shift();
              // alert(errors[k].pop());
              this.$emit("alert", {
                message: `${errors[k].pop()}`,
                type: "danger"
              });
            }
          } else {
            console.error(e);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    getError(name) {
      if (this.errors.has(name)) {
        return this.errors.first(name);
      } else return "";
    },

    gotoLogin() {
      if (this.isUsps) {
        window.location = "https://usps.grandshipper.com/admin/login";
      } else {
        router.push("/auth/login");
      }
    },

    uspsTitleSelect() {
      if (this.form.title && this.form.title.trim() == 'Other: (enter title)') {
        this.form.title = ''
        this.$refs.uspsTitle.show()
        this.$refs.uspsModalTitle.focus()
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/Auth/Register.vue